import { useContext, useEffect, useState } from 'react';
import './style.css'
import DropzoneEmpresaComponent, { FileWithPreview } from '../../../Dropzone';
import { useNavigate } from 'react-router-dom';
import { CadastroContext } from '../../../../contexts/CadastroContext';

const AsoValidarDocumentosEmpresa = () => {
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [isDisabled, setIsDisabled] = useState(true);
    const navigate = useNavigate();
    
    const handleFileChange = (newFiles: FileWithPreview[]) => {
        cadastro.files = newFiles;
        handleCadastroChange(cadastro);
    };

    const handleClick = () => {
        return navigate('/aso/registro/selecionar-responsavel');
    }

    useEffect(() => {
        if (cadastro.files && cadastro.files.length !== 0) setIsDisabled(false);
    }, [cadastro.files]);

    return (
        <>
            <div className='aso-validar-doc-empresa-body'>
                <h1 className='aso-validar-doc-empresa-title'>Envie o documento que autoriza você a agir em nome da Empresa</h1>
                <div className='aso-validar-doc-empresa-content'>
                    <p>Escolha um destes documentos e certifique-se de que esteja completo e legível:</p>
                    <br />
                    <p>- Certificado MEI, Certificado Simplificado ou Ficha Cadastral Completa ou Simplificada emitidos nos últimos 6 meses</p>
                    <br />
                    <p>- Estatuto ou Procuração de representação</p>
                    <br />
                    <p>- Termo de Posse de Administrador</p>
                    <br />
                    <p>- Você também pode consultar <a href="#" target='_blank'>outras opções de documentos</a> para enviar.</p>
                    <br />
                    <p>Dúvidas? <strong>Fale conosco pelo email comercial@medicoatento.com.br</strong></p>
                </div>
            </div>
            <DropzoneEmpresaComponent files={cadastro.files} onFileChange={handleFileChange} />
            <div className='aso-validar-doc-empresa-button-container'>
                <button className='aso-validar-doc-empresa-button' onClick={() => navigate('/aso/registro/funcao-empresa')}>Voltar</button>
                <button className='aso-validar-doc-empresa-button' onClick={handleClick} disabled={isDisabled}>Continuar</button>
            </div>
        </>
    );
}

export default AsoValidarDocumentosEmpresa;